import React, { useEffect, useState } from "react";
import {
  useSMTP,
  useNotifChannel,
} from "contexts/v1/pages/NotifChannelContext";
import Swal from "sweetalert2";

const SmtpForm = () => {
  const { smtpSettings, createSMTP, refetch } = useSMTP(); // Ambil smtpSettings dari context
  console.log("SMTP smtpSettings", smtpSettings);
  // Pada useEffect, pastikan data notifChannels ada
  const [formData, setFormData] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    encryption: "",
    from_address: "",
    from_name: "",
  });

  useEffect(() => {
    if (smtpSettings && smtpSettings.data) {
      setFormData({
        host: smtpSettings.data?.setting?.host || "",
        port: smtpSettings.data?.setting?.port || "",
        username: smtpSettings.data?.setting?.username || "",
        password: smtpSettings.data?.setting?.password || "",
        encryption: smtpSettings.data?.setting?.encryption || "",
        from_address: smtpSettings.data?.setting?.from_address || "",
        from_name: smtpSettings.data?.setting?.from_name || "",
      });
    }
  }, [smtpSettings]);

  // createSMTPHook
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createSMTP(formData);

      if (response.success) {
        Swal.fire("Saved!", "Your changes have been saved.", "success");
        refetch();
      }
    } catch (error) {
      Swal.fire("Error!", error.message, "error");
    }

    console.log("formData", formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    // host, port, username, password, encryption, from_address, from_name
    <div className="m-4">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="host" className="form-label">
            Host
          </label>
          <input
            type="text"
            className="form-control"
            id="host"
            name="host"
            placeholder="Enter your Host"
            value={formData.host}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="port" className="form-label">
            Port
          </label>
          <input
            type="text"
            className="form-control"
            id="port"
            name="port"
            placeholder="Enter your Port"
            value={formData.port}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="username" className="form-label">
            Username
          </label>
          <input
            type="text"
            className="form-control"
            id="username"
            name="username"
            placeholder="Enter your Username"
            value={formData.username}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            name="password"
            placeholder="Enter your Password"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="encryption" className="form-label">
            Encryption
          </label>
          <input
            type="text"
            className="form-control"
            id="encryption"
            name="encryption"
            placeholder="Enter your Encryption"
            value={formData.encryption}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="from_address" className="form-label">
            From Address
          </label>
          <input
            type="text"
            className="form-control"
            id="from_address"
            name="from_address"
            placeholder="Enter your From Address"
            value={formData.from_address}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="from_name" className="form-label">
            From Name
          </label>
          <input
            type="text"
            className="form-control"
            id="from_name"
            name="from_name"
            placeholder="Enter your From Name"
            value={formData.from_name}
            onChange={handleChange}
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Save
        </button>
      </form>
    </div>
  );
};

export default SmtpForm;
